import de_general from "@/utils/translations/de/general";
import en_general from "@/utils/translations/en/general";
import fr_general from "@/utils/translations/fr/general";
import es_general from "@/utils/translations/es/general";
import it_general from "@/utils/translations/it/general";
import pt_general from "@/utils/translations/pt/general";

import de_stat from "@/utils/translations/de/stat";
import en_stat from "@/utils/translations/en/stat";
import fr_stat from "@/utils/translations/fr/stat";
import es_stat from "@/utils/translations/es/stat";
import it_stat from "@/utils/translations/it/stat";
import pt_stat from "@/utils/translations/pt/stat";

import de_battle from "@/utils/translations/de/battle";
import en_battle from "@/utils/translations/en/battle";
import fr_battle from "@/utils/translations/fr/battle";
import es_battle from "@/utils/translations/es/battle";
import it_battle from "@/utils/translations/it/battle";
import pt_battle from "@/utils/translations/pt/battle";

import de_pokemonList from "@/utils/translations/de/pokemonList";
import en_pokemonList from "@/utils/translations/en/pokemonList";
import fr_pokemonList from "@/utils/translations/fr/pokemonList";
import es_pokemonList from "@/utils/translations/es/pokemonList";
import it_pokemonList from "@/utils/translations/it/pokemonList";
import pt_pokemonList from "@/utils/translations/pt/pokemonList";

import de_itemList from "@/utils/translations/de/itemList";
import en_itemList from "@/utils/translations/en/itemList";
import fr_itemList from "@/utils/translations/fr/itemList";
import es_itemList from "@/utils/translations/es/itemList";
import it_itemList from "@/utils/translations/it/itemList";
import pt_itemList from "@/utils/translations/pt/itemList";

import de_shop from "@/utils/translations/de/shop";
import en_shop from "@/utils/translations/en/shop";
import fr_shop from "@/utils/translations/fr/shop";
import es_shop from "@/utils/translations/es/shop";
import it_shop from "@/utils/translations/it/shop";
import pt_shop from "@/utils/translations/pt/shop";

const _translations = {
    "de": {
        general: de_general,
        stat: de_stat,
        battle: de_battle,
        pokemonList: de_pokemonList,
        itemList: de_itemList,
        shop: de_shop
    },
    "en": {
        general: en_general,
        stat: en_stat,
        battle: en_battle,
        pokemonList: en_pokemonList,
        itemList: en_itemList,
        shop: en_shop
    },
    "es": {
        general: es_general,
        stat: es_stat,
        battle: es_battle,
        pokemonList: es_pokemonList,
        itemList: es_itemList,
        shop: es_shop
    },
    "fr": {
        general: fr_general,
        stat: fr_stat,
        battle: fr_battle,
        pokemonList: fr_pokemonList,
        itemList: fr_itemList,
        shop: fr_shop
    },
    "it": {
        general: it_general,
        stat: it_stat,
        battle: it_battle,
        pokemonList: it_pokemonList,
        itemList: it_itemList,
        shop: it_shop
    },
    "pt": {
        general: pt_general,
        stat: pt_stat,
        battle: pt_battle,
        pokemonList: pt_pokemonList,
        itemList: pt_itemList,
        shop: pt_shop
    },
    "pt-br": {
        general: pt_general,
        stat: pt_stat,
        battle: pt_battle,
        pokemonList: pt_pokemonList,
        itemList: pt_itemList,
        shop: pt_shop
    }
};

const urlParams = new URLSearchParams(window.location.search);
const language = urlParams.get('language');

let translation;
if (language in _translations) {
    translation = _translations[language];
} else {
    translation = _translations["en"];
}

export {
    translation,
    language
};